<template>
  <div id="app">
    <template v-if="$store.state.role === 'user'">
      <!-- <keep-alive> -->
      <!-- 缓存所有的页面 -->
      <keep-alive :include="keepAlive">
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <!-- </keep-alive> -->
    </template>
    <template v-else>
      <template v-if="$store.state.user_info || $store.state.invite">
        <!-- <keep-alive> -->
        <!-- 缓存所有的页面 -->
        <keep-alive :include="keepAlive">
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <!-- </keep-alive> -->
      </template>
      <div class="no-login" v-else>
        <AppHeader ref="appHeader1" :hideNav="true" />
        <div class="des2">{{ $t('loginpage.text1') }}</div>
        <el-button class="el-button--special2 block" @click="handleLogin">{{
          $t('login')
        }}</el-button>
      </div>
    </template>
  </div>
</template>

<script>
import { postHomeConfig } from '@/api/user'

export default {
  name: 'App',
  computed: {
    keepAlive() {
      return this.$store.getters.keepAlive
    }
  },
  created() {
    console.log('打开app')
    console.log(process.env)
  },
  mounted() {
    window.addEventListener('beforeunload', (e) => this.beforeunloadHandler())
    postHomeConfig().then((res) => {
      this.$store.dispatch('setHomeConfig', res.data)
    })
  },
  methods: {
    beforeunloadHandler() {
      console.log('关闭app')
      localStorage.removeItem('inviteCode')
      localStorage.removeItem('inviteNft')
      localStorage.removeItem('inviteAct')
    },
    handleLogin() {
      this.$refs.appHeader1.handleLogin()
    }
  }
}
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
@import '@/assets/styles/common.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue